import { AccountManager } from "../Account/AccountManager";
import { Config } from "../config";
import { IframeMessaging } from "../Generals/iframeMessaging";
import { UserData } from "../Models/userData";
import { ConnexionPage } from "../Pages/connexionPage";
import { DemarchePage } from "../Pages/demarchePage";
import { FacturePage } from "../Pages/facturePage";
import { lostPasswordPage } from "../Pages/lostPasswordPage";
import { Menu } from "../Pages/menu";
import { ProfilPage } from "../Pages/profilePage";
import { VideoPage } from "../Pages/videoPage";
import { DataService } from "../Services/dataService";
import { PaymentService } from "../Services/paymentService";

export class FormManager {

    forms = [
        {
            page: "/t/qyaAHnUzBDus",
            callback: async () => {
                let calendarField = await this.waitForElement('#widget-tmcN input') as any;
                let immatElement = await this.waitForElement('#widget-u7RZ input') as any;

                immatElement.addEventListener("change", () => this.onImmatChange(immatElement, calendarField));
            }
        },
        {
            page: "/t/cfqYjJmMjius",
            callback: async () => {
                let calendarField = await this.waitForElement('#widget-tmcN input') as any;
                let immatElement = await this.waitForElement('#widget-u7RZ input') as any;

                immatElement.addEventListener("change", () => this.onImmatChange(immatElement, calendarField));
            }
        },
        {
            page: "/paiement-critair",

            callback: async () => {
                let paymentService = new PaymentService();
                let email = this.getHashEmail();
                paymentService.track(email, "page_paiement");

                //attend que Zapier ait créé le dossier, 30 secondes maximum
                const start = Date.now();
                let user: UserData | null = await new Promise((resolve) => {
                    const checkUser = async () => {
                        let u = null;
                        try {
                            u = await this.dataService.getUser(email);
                        } catch (e) {
                            console.log(e);
                        }

                        if (u) {
                            resolve(u);
                        } else if (Date.now() - start > 30000) {
                            resolve(null);
                        } else {
                            setTimeout(checkUser, 500);
                        }
                    };

                    checkUser();
                });

                if (!user) {
                    paymentService.showUserNotFound();
                    return;
                }

                paymentService.track(user.email, "data_ok");
                await paymentService.init(user);
            }
        },
        {
            page: "/test/payment.html",

            callback: async () => {
                let paymentService = new PaymentService();
                let email = document.location.hash.split('#')[1];

                let user: UserData = await new Promise((resolve) => {
                    const checkUser = async () => {
                        const u = await this.dataService.getUser(email);

                        if (u) {
                            resolve(u);
                        } else {
                            setTimeout(checkUser, 500);
                        }
                    };

                    checkUser();
                });


                await paymentService.init(user);
            }
        },
        {
            page: "/formation",
            callback: async () => {
                let menu = new Menu();
                let videoPage = new VideoPage();
            }
        },
        {
            page: "/connexion",
            callback: async () => {
                let connexionPage = new ConnexionPage();
            }
        },
        {
            page: "/facture",
            callback: async () => {
                let menu = new Menu();
                let facturePage = new FacturePage();
            }
        },
        {
            page: "/profil",
            callback: async () => {
                let menu = new Menu();
                let profilPage = new ProfilPage()
            }
        },
        {
            page: "/mot-de-passe-perdu",
            callback: async () => {
                let menu = new Menu();
                let lostpasswordPage = new lostPasswordPage();
            }
        },
        {
            page: "/demarche",
            callback: async () => {
                let menu = new Menu();
                let demarchePage = new DemarchePage();
            }
        }
    ];

    //email passé par Fillout après le # de l'URL, éventuellement encodé (%40, %2B...)
    getHashEmail(): string {
        const raw = document.location.hash.split('#')[1] || "";
        try {
            return decodeURIComponent(raw).trim();
        } catch (e) {
            return raw.trim();
        }
    }

    //recherche la date de 1ere immat via l'API plaque, le champ date est toujours deverrouille a la fin
    async onImmatChange(immatElement: any, calendarField: any) {
        this.lockCalendarField(calendarField);
        let val = calendarField.dataset.lockedValue || ""; // valeur saisie avant la recherche
        try {
            let rawResponse = await fetch("https://getImmat" + Config.functionUrl + "?i=" + encodeURIComponent(immatElement.value));
            let response = await rawResponse.json();
            const data = response?.data?.data;
            if (response.success && data?.date1erCir_us) {
                val = data.date1erCir_us.split('-').reverse().join('/');
            }
            else if (response.success && data?.date1erCir_fr) {
                val = data.date1erCir_fr.replaceAll('-', '/');
            }
        } catch (e) {
            console.log(e);
        } finally {
            this.unlockCalendarField(calendarField);
            this.setReactValue(calendarField, val);
        }
    }

    lockCalendarField(input: any) {

        if (!input) return;

        // Sauvegarde la valeur actuelle si besoin
        input.dataset.lockedValue = input.value;

        // Texte temporaire visible
        this.setReactValue(input, "Recherche en cours…");

        // Bloque l'interaction
        input.readOnly = true;
        input.style.opacity = "0.5";
        input.style.cursor = "wait";
        input.style.pointerEvents = "none";
    }

    unlockCalendarField(input: any) {
        if (!input) return;

        input.readOnly = false;
        input.style.opacity = "";
        input.style.cursor = "";
        input.style.pointerEvents = "";
    }

    disableNextButton(btn: any) {
        if (!btn) return;
        btn.disabled = true;
        btn.dataset.originalText = btn.textContent.trim();
        btn.textContent = "Chargement…";
        btn.style.opacity = "0.5";
        btn.style.cursor = "not-allowed";
    }

    enableNextButton(btn: any) {
        if (!btn) return;
        btn.disabled = false;
        btn.textContent = btn.dataset.originalText || "Suivant";
        btn.style.opacity = "";
        btn.style.cursor = "";
    }

    setReactValue(element: any, value: any) {
        // 1. Setter natif (contourne React controlled input)
        const nativeSetter = Object.getOwnPropertyDescriptor(
            window.HTMLInputElement.prototype, "value"
        )?.set;
        if (nativeSetter)
            nativeSetter.call(element, value);

        // 2. Mise à jour du state React interne via la fiber
        const fiberKey = Object.keys(element).find(k =>
            k.startsWith("__reactFiber") || k.startsWith("__reactInternalInstance")
        );

        if (fiberKey) {
            let fiber = element[fiberKey];

            // Remonte jusqu'au composant qui gère l'onChange
            while (fiber) {
                const onChange = fiber.memoizedProps?.onChange;
                if (onChange) {
                    // Simule un event synthétique React
                    onChange({ target: element, currentTarget: element, bubbles: true });
                    break;
                }
                fiber = fiber.return;
            }
        }

        // 3. Fallback : events natifs au cas où
        element.dispatchEvent(new Event("input", { bubbles: true }));
        element.dispatchEvent(new Event("change", { bubbles: true }));
    }

    dataService: DataService;
    constructor() {
        this.dataService = new DataService();
    }

    async init(): Promise<void> {
        await this.checkForm();
    }

    async setDateLikeUser(el: any, value: any) {


        el.focus();
        el.click();

        // Vide proprement

        el.dispatchEvent(new Event("input", { bubbles: true }));

        // Remplit caractère par caractère
        for (let char of value) {
            const current = el.value;

            el.dispatchEvent(new Event("input", { bubbles: true }));
            await new Promise(r => setTimeout(r, 20));
        }

        el.dispatchEvent(new Event("change", { bubbles: true }));
        el.blur();
    }


    async checkForm(): Promise<void> {
        const path = window.location.pathname;
        const form = this.forms.find(f => f.page == path);
        if (!form) return;

        await form.callback();
    }




    waitForElement(selector: string): Promise<Element | HTMLFormElement | HTMLElement | HTMLButtonElement> {
        return new Promise((resolve) => {
            const existing = document.querySelector(selector);
            if (existing) {
                return resolve(existing);
            }

            const observer = new MutationObserver(() => {
                const element = document.querySelector(selector);
                if (element) {
                    resolve(element);
                    observer.disconnect();
                }
            });

            observer.observe(document.body, { childList: true, subtree: true });
        })
    }

    interceptClick(buttonElement: any, callback: any) {
        buttonElement.addEventListener("click", async (event: any) => {
            if (!(buttonElement as any).isAlreadyClicked) {
                event.stopImmediatePropagation();
                (buttonElement as any).isAlreadyClicked = true;

                await callback();

                const newEvent = new MouseEvent("click", { bubbles: true, cancelable: true });
                buttonElement.dispatchEvent(newEvent);
            }
        }, true)
    }

}
